import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './lib/auth-context'
import './i18n'
import './index.css'

/* ── Service Worker Registration (PWA) ── */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[PWA] Service worker registered:', reg.scope)

        // Listen for new version messages from SW
        // Only reload once per session to avoid infinite loops
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data?.type === 'NEW_VERSION_AVAILABLE') {
            if (!sessionStorage.getItem('cherry_reloaded')) {
              console.log('[PWA] New version available, reloading once...')
              sessionStorage.setItem('cherry_reloaded', '1')
              window.location.reload()
            } else {
              console.log('[PWA] New version available, already reloaded this session')
            }
          }
        })

        // Check for updates periodically
        setInterval(
          () => {
            reg.update().catch(() => {
              // Silently fail — not critical
            })
          },
          60 * 60 * 1000, // every hour
        )

        // Force activate new service worker when found
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New SW is installed and old SW is still controlling — force skip waiting
                console.log('[PWA] New version installed, activating...')
                newWorker.postMessage({ type: 'SKIP_WAITING' })
              }
            })
          }
        })
      })
      .catch((err) => {
        console.log('[PWA] Service worker registration failed:', err)
      })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
